import * as React from 'react';
import {
  ChangeAction,
  OnAwaited_KeywordsChange_Action,
  OnBatchUpdateAction,
  OnChangeKeywordsAction,
  OnChangeResourceTypeAction,
  OnChangeStatusAction,
  OnClickLoadingMordAction,
  OnMountAction,
  OnUnmountAction,
} from '@/models/collectionListPage';
import { connect } from 'dva';
import { Dispatch } from 'redux';
import { CollectionListPageModelState, ConnectState } from '@/models/connect';
import FNoDataTip from '@/components/FNoDataTip';
import FLoadingTip from '@/components/FLoadingTip';
import { FI18n, FUtil } from '@freelog/tools-lib';
import * as AHooks from 'ahooks';
import styles from './index.less';
import FResourceTypeFilter from '@/components/FResourceTypeFilter';
import FComponentsLib from '@freelog/components-lib';
import { Affix, Checkbox, Space } from 'antd';
import FListFooter from '@/components/FListFooter';
import fPolicyBuilder from '@/components/fPolicyBuilder';
import fPromiseModalConfirm from '@/components/fPromiseModalConfirm';
import fSignResourceToNode from '@/components/fSignResourceToNode';
import { history } from 'umi';
import fBatchHandleResource_ResultModal from '@/components/fBatchHandleResource_ResultModal';
import FCoverImage from '@/components/FCoverImage';
import FTooltip from '@/components/FTooltip';
import img_choiceLabel from '@/assets/choice-label@2x.png';
import FResourceStatusBadge from '@/components/FResourceStatusBadge';
import FCoverFooterButtons from '@/components/FCoverFooterButtons';
import FHotspotTooltip, { fSetHotspotTooltipVisible } from '@/components/FHotspotTooltip';
import FIcons from '@/components/FIcons';
// import FDropdownMenu from '@/components/FDropdownMenu';
import FDropdown2 from '@/components/FDropdown2';
import FInput_Search from '@/components/FInput_Search';

interface ResourceProps {
  dispatch: Dispatch;
  collectionListPage: CollectionListPageModelState;
}

function Resources({ dispatch, collectionListPage }: ResourceProps) {
  const [$resourceStatusOptions, set$resourceStatusOptions] = FUtil.Hook.useGetState([
    { text: FI18n.i18nNext.t('filter_resource_status_all'), value: '#' },
    {
      // 上架
      text: FI18n.i18nNext.t('filter_resource_status_availableforauth'),
      value: 1,
    },
    {
      // 下架
      text: FI18n.i18nNext.t('filter_resource_status_pendingauth'),
      value: 4,
    },
    // { text: '待发行', value: 0 },
    // { text: FI18n.i18nNext.t('filter_resource_status_prepareforrelease'), value: 0 },
    // { text: '冻结', value: 2 },
    {
      // 冻结
      text: FI18n.i18nNext.t('filter_resource_status_removedbyfreelog'),
      value: 2,
    },
  ]);

  const [$affixed, set$affixed, get$affixed] = FUtil.Hook.useGetState<boolean>(false);

  AHooks.useMount(() => {
    dispatch<OnMountAction>({
      type: 'collectionListPage/onMount',
    });
  });

  AHooks.useUnmount(() => {
    dispatch<OnUnmountAction>({
      type: 'collectionListPage/onUnmount',
    });
  });

  AHooks.useDebounceEffect(
    () => {
      dispatch<OnAwaited_KeywordsChange_Action>({
        type: 'collectionListPage/onAwaited_KeywordsChange',
      });
    },
    [collectionListPage.inputText],
    {
      wait: 300,
    },
  );

  AHooks.useDebounceEffect(
    () => {
      const allIDs: string[] = collectionListPage.resource_List
        .filter((ol) => {
          return ol.status !== 2;
        })
        .map((ol) => {
          return ol.id;
        });
      // console.log('allIDs sdifjlsdkjflksdjflkjlkj');
      dispatch<ChangeAction>({
        type: 'collectionListPage/change',
        payload: {
          checkedResourceIDs: collectionListPage.checkedResourceIDs.filter((id) => {
            return allIDs.includes(id);
          }),
        },
      });
    },
    [collectionListPage.resource_List],
    {
      wait: 30,
    },
  );

  if (collectionListPage.resource_ListState === 'loading') {
    return <FLoadingTip height={'calc(100vh - 140px)'} />;
  }

  if (collectionListPage.resource_ListState === 'noData') {
    return (
      <FNoDataTip
        height={'calc(100vh - 140px)'}
        // tipText={'未创建任何资源'}
        tipText={FI18n.i18nNext.tJSXElement('my_collections_empty')}
        // btnText={'创建资源'}
        btnText={FI18n.i18nNext.t('my_collections_empty_btn')}
        onClick={() => {
          self.open(FUtil.LinkTo.resourceCreatorEntry());
        }}
      />
    );
  }

  return (
    <div className={styles.content}>
      <div style={{ height: 40 }} />
      <div className={styles.filter}>
        <div className={styles.filterLeft}>
          <FComponentsLib.FRectBtn
            onClick={() => {
              self.open(FUtil.LinkTo.collectionCreator());
            }}
          >
            {/*创建合集*/}
            {FI18n.i18nNext.t('my_collections_btn_createcollection')}
          </FComponentsLib.FRectBtn>
          {!collectionListPage.isBatchManagement && (
            <>
              <div style={{ width: 30 }} />
              <FHotspotTooltip
                id={'myCollectionList.batchManagementButton'}
                // style={{ right: -50, top: -4 }}
                style={{ left: 20, bottom: -38 }}
                text={FI18n.i18nNext.t('hotpots_mycollection_bulkaction')}
                onOpenChange={(o) => {
                  if (o) {
                    fSetHotspotTooltipVisible('myCollectionList.batchManagementButton', {
                      value: false,
                      effectiveImmediately: false,
                      onlyNullish: false,
                    });
                  }
                }}
              >
                <FComponentsLib.FTextBtn
                  style={{ fontSize: 14 }}
                  onClick={() => {
                    fSetHotspotTooltipVisible('myCollectionList.batchManagementButton', {
                      value: false,
                      effectiveImmediately: true,
                      onlyNullish: false,
                    });
                    dispatch<ChangeAction>({
                      type: 'collectionListPage/change',
                      payload: {
                        isBatchManagement: true,
                      },
                    });
                  }}
                >
                  <FIcons.FConfiguration style={{ fontSize: 14 }} />
                  &nbsp;{FI18n.i18nNext.t('my_collections_btn_bulkaction')}
                </FComponentsLib.FTextBtn>
              </FHotspotTooltip>
            </>
          )}
          <div style={{ width: 30 }} />
          <div>
            <span>{FI18n.i18nNext.t('resource_type')}：</span>
            <FResourceTypeFilter
              value={collectionListPage.resourceTypeCodes}
              onChange={(value) => {
                dispatch<OnChangeResourceTypeAction>({
                  type: 'collectionListPage/onChangeResourceType',
                  payload: {
                    value: value,
                  },
                });
              }}
              subjectType={'collection'}
            />
          </div>
          <div style={{ width: 60 }} />
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span>{FI18n.i18nNext.t('resource_state')}：</span>

            {/* <FDropdownMenu
              options={$resourceStatusOptions as any}
              onChange={(value) => {
                dispatch<OnChangeStatusAction>({
                  type: 'collectionListPage/onChangeStatus',
                  payload: {
                    value: value === '#' ? value : (Number(value) as 0),
                  },
                });
              }}
              text={
                $resourceStatusOptions.find((rs) => {
                  return rs.value === collectionListPage.resourceStatus;
                })?.text || ''
              }
            /> */}

            <FDropdown2
              autoArrow={true}
              // getPopupContainer={() => ref_Root.current as HTMLElement}
              menu={{
                // selectedKeys: [nodeManagerPage.exhibit_SelectedStatus],
                items: $resourceStatusOptions.map((rs) => {
                  return {
                    key: rs.value,
                    label: rs.text,
                  };
                }),
                onClick: (value) => {
                  dispatch<OnChangeStatusAction>({
                    type: 'collectionListPage/onChangeStatus',
                    payload: {
                      value: value.key === '#' ? value.key : (Number(value.key) as 0),
                    },
                  });
                },
              }}
            >
              <span>
                {$resourceStatusOptions.find((rs) => {
                  return rs.value === collectionListPage.resourceStatus;
                })?.text || ''}
              </span>
            </FDropdown2>
          </div>
        </div>
        <Space size={20}>
          {/* <FComponentsLib.FInput.FSearch */}
          <FInput_Search
            value={collectionListPage.inputText}
            style={{ width: 400 }}
            placeholder={FI18n.i18nNext.t('my_collections_search_hint')}
            onChange={(e) => {
              dispatch<OnChangeKeywordsAction>({
                type: 'collectionListPage/onChangeKeywords',
                payload: {
                  value: e.target.value,
                },
              });
            }}
          />
        </Space>
      </div>

      {collectionListPage.resource_ListState === 'noSearchResult' && (
        <FNoDataTip
          height={'calc(100vh - 220px)'}
          // tipText={'没有符合条件的资源'}
          tipText={FI18n.i18nNext.t('msg_search_no_resault_found', {
            SearchKeyWords: collectionListPage.inputText_search,
          })}
          btnText={'创建资源'}
          onClick={() => {
            self.open(FUtil.LinkTo.resourceCreatorEntry());
          }}
        />
      )}

      {collectionListPage.resource_ListState === 'loaded' && (
        <>
          <div style={{ height: 15 }} />

          {collectionListPage.isBatchManagement && (
            <>
              <Affix
                offsetTop={0}
                target={() => {
                  return self.document.querySelector(
                    '#layout-content .simplebar-content-wrapper',
                  ) as HTMLElement;
                }}
                onChange={(affixed) => {
                  set$affixed(affixed ?? false);
                }}
              >
                <div
                  className={styles.batchHandle}
                  style={
                    $affixed
                      ? {
                          backgroundColor: 'white',
                          margin: '0 -1000px',
                          height: 70,
                        }
                      : {}
                  }
                >
                  <div className={styles.batchHandleCenter}>
                    <div className={styles.batchHandleLeft}>
                      <Checkbox
                        checked={
                          collectionListPage.checkedResourceIDs.length !== 0 &&
                          collectionListPage.checkedResourceIDs.length ===
                            collectionListPage.resource_List.filter((r) => {
                              return r.status !== 2;
                            }).length
                        }
                        indeterminate={
                          collectionListPage.checkedResourceIDs.length !== 0 &&
                          collectionListPage.checkedResourceIDs.length !==
                            collectionListPage.resource_List.filter((r) => {
                              return r.status !== 2;
                            }).length
                        }
                        onChange={(e) => {
                          if (e.target.checked) {
                            dispatch<ChangeAction>({
                              type: 'collectionListPage/change',
                              payload: {
                                checkedResourceIDs: collectionListPage.resource_List
                                  .filter((o) => {
                                    return o.status !== 2;
                                  })
                                  .map((o) => {
                                    return o.id;
                                  }),
                              },
                            });
                          } else {
                            dispatch<ChangeAction>({
                              type: 'collectionListPage/change',
                              payload: {
                                checkedResourceIDs: [],
                              },
                            });
                          }
                        }}
                      />
                      <div style={{ width: 10 }} />
                      <FComponentsLib.FContentText
                        text={FI18n.i18nNext.t('myresources_bulkaction_checkbox_selectall')}
                        type={'normal'}
                      />
                      <div style={{ width: 30 }} />
                      <FComponentsLib.FContentText
                        // text={`已选择${resourceListPage.checkedResourceIDs.length}个资源`}
                        text={FI18n.i18nNext.t('myresources_bulkaction_label_selectedqty', {
                          Qty: collectionListPage.checkedResourceIDs.length,
                        })}
                        type={'additional2'}
                        style={{ fontSize: 14 }}
                      />
                    </div>

                    <div className={styles.batchHandleRight}>
                      <FComponentsLib.FTextBtn
                        disabled={collectionListPage.checkedResourceIDs.length === 0}
                        type={'primary'}
                        onClick={async () => {
                          const result = await fSignResourceToNode({
                            resourceIDs: collectionListPage.checkedResourceIDs,
                          });
                          // console.log(result, 'result sdifjhsldkjflksjdlfjlsdjflsdjfl');
                          if (result) {
                            if (
                              Object.values(result.resultData).some((v) => {
                                return v.status === 2;
                              })
                            ) {
                              // fCenterMessage({ message: '资源状态异常，无法添加' });
                              await fBatchHandleResource_ResultModal({
                                type: 'signNode',
                                dataSource: result.resultData,
                              });
                            }

                            if (result.allIsTheme) {
                              history.push(
                                FUtil.LinkTo.nodeManagement({
                                  nodeID: result.nodeID,
                                  showPage: 'theme',
                                }),
                              );
                            } else {
                              history.push(
                                FUtil.LinkTo.nodeManagement({
                                  nodeID: result.nodeID,
                                }),
                              );
                            }
                          }
                        }}
                      >
                        <FIcons.FNodes style={{ fontSize: 14, color: '#2784FF' }} />
                        &nbsp;
                        {FI18n.i18nNext.t('myresources_bulkaction_btn_addtomynode')}
                      </FComponentsLib.FTextBtn>

                      <FComponentsLib.FTextBtn
                        disabled={collectionListPage.checkedResourceIDs.length === 0}
                        type={'primary'}
                        onClick={() => {
                          dispatch<OnBatchUpdateAction>({
                            type: 'collectionListPage/onBatchUpdate',
                            payload: {
                              status: 1,
                            },
                          });
                        }}
                      >
                        <FIcons.FUpcast style={{ fontSize: 14 }} />
                        &nbsp;
                        {FI18n.i18nNext.t('myresources_bulkaction_btn_availabletoauth')}
                      </FComponentsLib.FTextBtn>

                      <FComponentsLib.FTextBtn
                        disabled={collectionListPage.checkedResourceIDs.length === 0}
                        type={'primary'}
                        onClick={async () => {
                          const bool: boolean = await fPromiseModalConfirm({
                            title: FI18n.i18nNext.t('remove_resource_from_auth_confirmation_title'),
                            description: FI18n.i18nNext.t('confirm_msg_remove_resource_from_auth'),
                            okText: FI18n.i18nNext.t('remove_resource_from_auth_btn_remve'),
                            promptKey_localStorage:
                              FI18n.i18nNext.t('remove_resource_from_auth_confirmation_title') ||
                              '',
                          });

                          if (bool) {
                            dispatch<OnBatchUpdateAction>({
                              type: 'collectionListPage/onBatchUpdate',
                              payload: {
                                status: 4,
                              },
                            });
                          }
                        }}
                      >
                        <FIcons.FUpcast style={{ fontSize: 14, transform: 'rotate(180deg)' }} />
                        &nbsp;
                        {FI18n.i18nNext.t('myresources_bulkaction_removefromauth')}
                      </FComponentsLib.FTextBtn>

                      <FComponentsLib.FTextBtn
                        type={'primary'}
                        disabled={collectionListPage.checkedResourceIDs.length === 0}
                        onClick={async () => {
                          const result = await fPolicyBuilder({
                            targetType: 'resource',
                          });
                          if (!result) {
                            return;
                          }

                          dispatch<OnBatchUpdateAction>({
                            type: 'collectionListPage/onBatchUpdate',
                            payload: {
                              addPolicies: [
                                {
                                  policyName: result.title,
                                  policyText: result.text,
                                  status: 1,
                                },
                              ],
                            },
                          });
                        }}
                      >
                        <FIcons.FPolicy style={{ fontSize: 14 }} />
                        &nbsp;
                        {FI18n.i18nNext.t('myresources_bulkaction_btn_addauthplan')}
                      </FComponentsLib.FTextBtn>

                      <FComponentsLib.FTextBtn
                        type={'danger'}
                        onClick={() => {
                          dispatch<ChangeAction>({
                            type: 'collectionListPage/change',
                            payload: {
                              isBatchManagement: false,
                              checkedResourceIDs: [],
                            },
                          });
                        }}
                      >
                        <FIcons.FExit style={{ fontSize: 14 }} />
                        &nbsp;
                        {FI18n.i18nNext.t('myresources_bulkaction_btn_quit')}
                      </FComponentsLib.FTextBtn>
                    </div>
                  </div>
                </div>
              </Affix>
              <div style={{ height: 15 }} />
            </>
          )}

          <div className={styles.Content}>
            {collectionListPage.resource_List.map((i, j) => {
              return (
                <div
                  key={i.id}
                  className={styles.collectionContainer}
                  onClick={() => {
                    if (collectionListPage.isBatchManagement) {
                      if (i.status === 2) {
                        return;
                      }
                      if (!collectionListPage.checkedResourceIDs.includes(i.id)) {
                        dispatch<ChangeAction>({
                          type: 'collectionListPage/change',
                          payload: {
                            checkedResourceIDs: [...collectionListPage.checkedResourceIDs, i.id],
                          },
                        });
                      } else {
                        dispatch<ChangeAction>({
                          type: 'collectionListPage/change',
                          payload: {
                            checkedResourceIDs: collectionListPage.checkedResourceIDs.filter(
                              (id) => {
                                return id !== i.id;
                              },
                            ),
                          },
                        });
                      }
                    }
                  }}
                >
                  {collectionListPage.isBatchManagement && (
                    <>
                      <div>
                        <Checkbox
                          checked={collectionListPage.checkedResourceIDs.includes(i.id)}
                          disabled={i.status === 2}
                        />
                      </div>
                      <div style={{ height: 10 }} />
                    </>
                  )}

                  <div className={styles.collectionCard} key={i.id}>
                    <div className={styles.collectionCardLeft}>
                      <div
                        style={{
                          display: 'block',
                          width: 'fit-content',
                          height: 'fit-content',
                          position: 'relative',
                        }}
                      >
                        <FCoverImage src={i.cover} width={280} style={{ borderRadius: 4 }} />

                        <div
                          style={{
                            position: 'absolute',
                            top: 10,
                            left: 10,
                            display: 'flex',
                            alignItems: 'center',
                            gap: 10,
                          }}
                        >
                          <FResourceStatusBadge
                            status={
                              i.status === 2
                                ? 'freeze'
                                : i.status === 1
                                ? 'online'
                                : i.status === 0
                                ? 'unreleased'
                                : 'offline'
                            }
                          />

                          {i.authProblem && (
                            <FTooltip
                              // title={'存在授权问题'}
                              title={FI18n.i18nNext.t('alert_resource_no_auth')}
                            >
                              <FIcons.FWarning style={{ fontSize: 16 }} />
                            </FTooltip>
                          )}

                          {i.isChoice && (
                            <FTooltip title={'编辑精选'} placement={'bottomLeft'}>
                              <img
                                src={img_choiceLabel}
                                alt={''}
                                style={{ width: 24, height: 24 }}
                              />
                            </FTooltip>
                          )}
                        </div>
                        <nav className={styles.CoverMask}>
                          <FCoverFooterButtons
                            buttons={[
                              {
                                type: 'resourceDetails',
                                text: FI18n.i18nNext.t('my_collections_card_btn_viewdetails'),
                                fn() {
                                  // onClickDetails && onClickDetails();
                                  self.open(
                                    FUtil.LinkTo.collectionDetails({
                                      collectionID: i.id,
                                    }),
                                  );
                                },
                              },
                              {
                                type: 'edit',
                                fn() {
                                  // onClickEditing && onClickEditing();
                                  self.open(
                                    FUtil.LinkTo.collectionVersionInfo({
                                      collectionID: i.id,
                                    }),
                                  );
                                },
                              },
                              // {
                              //   type: 'update',
                              //   fn() {
                              //     // onClickRevision && onClickRevision();
                              //   },
                              // },
                            ]}
                          />
                        </nav>
                      </div>
                      <div style={{ height: 10 }} />
                      <FComponentsLib.FContentText
                        text={i.title || i.name.split('/')[1]}
                        type={'highlight'}
                        singleRow
                      />
                      <div style={{ height: 5 }} />
                      <FComponentsLib.FContentText text={i.type.join('/')} type={'additional2'} />
                      <div style={{ height: 5 }} />
                      <FComponentsLib.FContentText
                        // text={`最新更新时间 ${i.updateDate}`}
                        text={FI18n.i18nNext.t('resource_card_label_lastupdated', {
                          LatestUpdatedTime: i.updateDate,
                        })}
                        type={'additional2'}
                      />
                      <div style={{ height: 5 }} />
                      <div className={styles.collectionCardLeftPolicy}>
                        {i.policy.length > 0 ? (
                          <FComponentsLib.F_Contract_And_Policy_Labels
                            data={i.policy.map((p) => {
                              return {
                                text: p,
                                dot: '',
                              };
                            })}
                            singleRow
                          />
                        ) : (
                          <FComponentsLib.FContentText
                            // text={'暂无策略…'}
                            text={FI18n.i18nNext.t('resource_card_msg_noplans')}
                            type='additional2'
                          />
                        )}
                      </div>
                    </div>
                    <div className={styles.collectionCardDivider} />
                    <div className={styles.collectionCardRight}>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 10,
                        }}
                      >
                        {i.isFinish ? (
                          <label className={[styles.label, styles.finished].join(' ')}>
                            {/* 已完结 */}
                            {FI18n.i18nNext.t('cqr_itemmgmt_updatedstates_completed')}
                          </label>
                        ) : (
                          // : (<label className={[styles.label, styles.updating].join(' ')}>连载中</label>)
                          <label className={[styles.label, styles.updating].join(' ')}>
                            {FI18n.i18nNext.t('cqr_itemmgmt_updatestates_ongoing')}
                          </label>
                        )}
                        <FComponentsLib.FContentText
                          type={'additional2'}
                          style={{ color: '#222' }}
                          // text={`共${i.itemsCount}个单品`}
                          text={FI18n.i18nNext.t('my_collections_card_itemcount', {
                            itemCount: i.itemsCount,
                          })}
                        />
                      </div>
                      <div style={{ height: 10 }} />
                      <FComponentsLib.FContentText
                        // text={'最近更新'}
                        text={FI18n.i18nNext.t('my_collections_card_lastupdated')}
                        type={'additional2'}
                      />
                      <div style={{ height: 10 }} />
                      <div
                        style={{
                          display: 'flex',
                          width: '100%',
                          flexDirection: 'column',
                          gap: 5,
                          height: 225,
                        }}
                      >
                        {i.itemsNames.length === 0 && (
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 5,
                            }}
                          >
                            <FComponentsLib.FContentText
                              // text={'（暂无更新）'}
                              text={FI18n.i18nNext.t('resource_card_collection_empty')}
                              type={'additional2'}
                              style={{
                                color: '#222',
                                maxWidth: 260,
                                fontStyle: 'italic',
                              }}
                              singleRow
                            />
                          </div>
                        )}

                        {i.itemsNames.length > 0 &&
                          i.itemsNames.map((v, index) => {
                            return (
                              <div
                                key={index}
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 5,
                                }}
                              >
                                <i
                                  style={{
                                    width: 4,
                                    height: 4,
                                    borderRadius: '50%',
                                    backgroundColor: '#C9C9C9',
                                  }}
                                />
                                <FComponentsLib.FContentText
                                  text={v}
                                  type={'additional2'}
                                  style={{ color: '#222', maxWidth: 260 }}
                                  singleRow
                                />
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
            <div className={styles.bottomPadding} />
          </div>
          <div style={{ height: 100 }} />

          <FListFooter
            state={collectionListPage.resource_ListMore}
            onClickLoadMore={async () => {
              dispatch<OnClickLoadingMordAction>({
                type: 'collectionListPage/onClickLoadingMord',
              });
            }}
          />
        </>
      )}
      <div style={{ height: 100 }} />
    </div>
  );
}

export default connect(({ collectionListPage }: ConnectState) => ({
  collectionListPage: collectionListPage,
}))(Resources);
